import axios from "axios";
import {
  GitHubCopilotBudgetMember,
  GitHubCopilotUsage,
  GitHubCopilotUserBudgets,
  SetGitHubCopilotBudgetRequest,
} from "./models/GitHubCopilotBudget";

export const getProjectGitHubCopilotBudgets = async (
  projectId: string,
): Promise<GitHubCopilotBudgetMember[]> => {
  const { data } = await axios.get<GitHubCopilotBudgetMember[]>(
    `${window.configuration.apiUrl}api/projects/${projectId}/github-copilot-budgets`,
  );
  return data;
};

export const setGitHubCopilotBudget = async (
  projectId: string,
  request: SetGitHubCopilotBudgetRequest,
): Promise<void> => {
  await axios.put(
    `${window.configuration.apiUrl}api/projects/${projectId}/github-copilot-budgets`,
    request,
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
};

export const getUserGitHubCopilotBudgets = async (
  memberId: string,
): Promise<GitHubCopilotUserBudgets> => {
  const { data } = await axios.get<GitHubCopilotUserBudgets>(
    `${window.configuration.apiUrl}api/users/${memberId}/github-copilot-budgets`,
  );
  return data;
};

export const getUserGitHubCopilotUsage = async (
  memberId: string,
): Promise<GitHubCopilotUsage> => {
  const { data } = await axios.get<GitHubCopilotUsage>(
    `${window.configuration.apiUrl}api/users/${memberId}/github-copilot-usage`,
  );
  return data;
};
